import React, { useState, useEffect } from 'react';
import { APIROOT } from '../../../Helpers/configs';

import RepairTicketCabinetInfo from './RepairTicketCabinetInfo';

import { Box, Grid, Divider, Button } from '@mui/material';

const RepairTicketCabinet = (props) => {
  const customerName = props.customerName;
  const serialsDataList = props.serialsDataList;
  const onBlurEventsCapture = props.onBlurEventsCapture;
  const selectedStoreName = props.customerName;
  const deleteCabinet = props.deleteCabinet;

  const [fullSerialNumbersList, setFullSerialNumbersList] = useState([]);

  const [cabinetsList, setCabinetsList] = useState([]);

  const [loggedCabinets, setLoggedCabinets] = useState(serialsDataList);

  //GET FULL SERIALS LIST
  useEffect(() => {
    let customerName = selectedStoreName;
    if (
      customerName === null ||
      customerName === undefined ||
      customerName === ''
    ) {
      setFullSerialNumbersList([]);
    } else {
      serialsByCustomer(customerName).then((data) => {
        setFullSerialNumbersList(data.data.value);
        mapAvailableCabinetTypes(data.data.value);
      });
    }
  }, [selectedStoreName]);

  async function mapAvailableCabinetTypes(fullSerialList) {
    let cabinetsTypes;
    cabinetsTypes = fullSerialList.map((obj) => ({
      id: obj.cabinet_type_id,
      name: obj.cabinet_name,
    }));
    let distinctCabinetTypes;
    try {
      let cab = 'name';
      distinctCabinetTypes = [
        ...new Map(cabinetsTypes.map((obj) => [obj[cab], obj])).values(),
      ];
    } catch (error) {
      distinctCabinetTypes = [...cabinetsTypes];
    }

    setCabinetsList(distinctCabinetTypes);
  }

  const updateCabinets = () => {};

  const removeCabinet = () => {};

  const [history, setHistory] = useState([]);

  return (
    <Box>
      {serialsDataList.map((obj, index) => {
        return (
          <Box key={index} margin='10px'>
            <RepairTicketCabinetInfo
              // customer={customer}
              cabinetId={obj.id}
              customerName={customerName}
              cabinetData={obj}
              cabinetsList={cabinetsList}
              fullSerialList={fullSerialNumbersList}
              onBlurEventsCapture={onBlurEventsCapture}
            />
            <Grid
              container
              xs={10}
              md={10}
              flexDirection='row'
              rowGap={1}
              // columnGap={1}
              alignContent='flex-start'
            >
              <Grid
                sx={{ margin: '0 0 40px 0' }}
                container
                xs={1}
                md={1}
                flexDirection='row'
                rowGap={1}
                columnGap={1}
                alignContent='flex-start'
              >
                <Grid item xs={10}>
                  <Button
                    fullWidth
                    variant='contained'
                    color='warning'
                    onClick={() => {
                      const delId = obj.id;

                      deleteCabinet(
                        serialsDataList.filter((cab) => {
                          return cab.id !== delId;
                        })
                      );
                    }}
                  >
                    Delete
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Divider />
          </Box>
        );
      })}
    </Box>
  );
};

export default RepairTicketCabinet;

async function serialsByCustomer(customerName) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'store_name',
            search: customerName,
            strict: true,
          },
        ],
      },
    },
  };

  const request = new Request(`${APIROOT}/api/serialnumbers`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}
